import { isValidPhoneNumber } from 'react-phone-number-input';
import { z } from 'zod';

export const putProfileResolverSchema = (requiredFields?: string[]) =>
	z
		.object({
			flow: z
				.enum(['CompleteDetails', 'IncompleteAboutSection', 'View'])
				.optional(),
			id: z.string().trim(),
			firstName: requiredFields?.includes('FirstName')
				? z.string().min(3, 'First name is required')
				: z.string().trim().optional().nullable(),
			lastName: requiredFields?.includes('LastName')
				? z.string().min(3, 'Last name is required')
				: z.string().trim().optional().nullable(),
			dateOfBirth: z.string(),
			birthDay: z.number(),
			birthMonth: z.number(),
			birthYear: z.number(),
			gender: requiredFields?.includes('Gender')
				? z.string().min(1, 'Gender is required')
				: z.string().trim().optional().nullable(),
			ethnicity: z.string().trim().optional().nullable(),
			genderCommunity: z.string().trim().optional().nullable(),
			nickname: z.string().trim().optional().nullable(),
			language: z.string().trim().optional().nullable(),
			favouritePlayerId: z.coerce.string().optional().nullable(),
			fanSince: z.coerce.number().optional().nullable(),
			countryCode: requiredFields?.includes('CountryCode')
				? z.string().min(2, 'Country is required')
				: z.string().trim().optional().nullable(),
			state: z.string().optional(),
			addressLine1: requiredFields?.includes('AddressLine1')
				? z.string().min(3, 'Address line 1 is required')
				: z.string().trim().optional().nullable(),
			addressLine2: z.string().trim().optional().nullable(),
			addressLine3: z.string().trim().optional().nullable(),
			city: requiredFields?.includes('City')
				? z.string().trim().min(3, 'Town / City is required')
				: z.string().trim().optional().nullable(),
			zip: requiredFields?.includes('Zip')
				? z.string().min(3, 'Post code / ZIP code is required')
				: z.string().trim().optional().nullable(),
			homeNumber: z
				.string()
				.trim()
				.refine(isValidPhoneNumber, { message: 'Invalid phone number' })
				.optional()
				.nullable(),
			mobileNumber: requiredFields?.includes('MobileNumber')
				? z.coerce
					.string()
					.trim()
					.min(6, 'Mobile phone is required')
					.refine(isValidPhoneNumber, {
						message: 'Invalid phone number',
					})
				: z.coerce
					.string()
					.trim()
					.refine(isValidPhoneNumber, {
						message: 'Invalid phone number',
					})
					.optional()
					.nullable(),
			email: requiredFields?.includes('Email')
				? z
					.string()
					.email('Email is invalid')
					.trim()
					.min(3, 'Email is required')
				: z
					.string()
					.email('Email is invalid')
					.trim()
					.optional()
					.nullable(),
			supporterNumber: z.coerce.number().optional().nullable(),
		})
		.refine(
			(data) => {
				const { countryCode } = data;

				if (countryCode === 'CA' || countryCode === 'US') {
					return !!data.state;
				}

				return true;
			},
			{
				message:
					'State is required',
				path: ['state'],
			}
		)
		.refine((data) => {
			if (data.flow === 'CompleteDetails') {
				return !!data.dateOfBirth;
			}
			return !!data.birthDay && !!data.birthMonth && !!data.birthYear;
		}, {
			message: 'Invalid Date of Birth',
		});
